import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Change password template component
 */
export class ChangePasswordComponent {
  @Input() formGroup!: UntypedFormGroup;
  @Output() clickSubmit = new EventEmitter<any>();

  /**
   * Action to take when submit button is clicked
   */
  onSubmit() {
    this.clickSubmit.emit();
  }
}
